import { useState } from 'react';
import * as S from './CustomFilter.styled';
import { Search, ClearSearchInput } from 'assets/icons';
import { FiltersMenu, AppTypeFilterMenu } from 'components';
import uuid from 'react-uuid';

const CustomFilter = ({
  searchValue,
  searchOnChange,
  clearSearchValue,
  handleChangeFilterState,
  filterState,
  appTypeFilterState,
  handleChangeAppTypeFilter,
  hideAppTypeFilter = false,
}) => {
  const [searchInputFocus, setSearchInputFocus] = useState(false);

  return (
    <S.Container>
      <S.SearchIconWraper isFocusable={searchInputFocus}>
        <Search />
      </S.SearchIconWraper>
      <S.SearchInput
        id={uuid()}
        placeholder='Search App'
        onFocus={() => setSearchInputFocus(true)}
        onBlur={() => setSearchInputFocus(false)}
        value={searchValue}
        onChange={searchOnChange}
      />
      <S.ClearSearchInputWrapper visible={searchValue.length > 0} onClick={clearSearchValue}>
        <ClearSearchInput />
      </S.ClearSearchInputWrapper>
      {!hideAppTypeFilter && (
        <S.WrapForRightIcon>
          <AppTypeFilterMenu
            handleChangeAppTypeFilter={handleChangeAppTypeFilter}
            appTypeFilterState={appTypeFilterState}
          />
        </S.WrapForRightIcon>
      )}
      <S.WrapForRightIcon>
        <FiltersMenu handleChangeFilterState={handleChangeFilterState} filterState={filterState} />
      </S.WrapForRightIcon>
    </S.Container>
  );
};

export default CustomFilter;
